exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customButtonClass{background:#fff;border:1px solid #007ee6;color:#007ee6;font-size:.9vw;border-radius:.2vw;padding:.37vw .9vw;margin:0px 0px 0px 10px;box-shadow:0 5px 10px rgba(0,0,0,.1)}.customRedButtonClass{background:#fff;border:1px solid red;color:red;font-size:.9vw;border-radius:.2vw;padding:.4vw .9vw;margin:0px 0px 0px 10px;box-shadow:0 5px 10px rgba(0,0,0,.1)}", ""]);

// exports
